import { createReducer, createActions } from 'reduxsauce';
import Immutable from 'seamless-immutable';

/* Types & Action Creators */

const { Types, Creators } = createActions({
  getNaturezasRequest: null,
  getNaturezasSuccess: ['naturezas'],
  getNaturezasFailure: ['error'],
  addNaturezaRequest: ['natureza', 'closeModal'],
  addNaturezaSuccess: ['natureza'],
  addNaturezaFailure: ['error'],
  updateNaturezaRequest: ['natureza', 'closeModal'],
  updateNaturezaSuccess: ['natureza'],
  updateNaturezaFailure: ['error'],
  removeNaturezaRequest: ['id'],
  removeNaturezaSuccess: ['id'],
  removeNaturezaFailure: ['error'],
  openModal: null,
  closeModal: null,
  setNaturezaActive: ['natureza'],
});

export const NaturezasTypes = Types;
export default Creators;

/* Initial State */

export const INITIAL_STATE = Immutable({
  naturezas: [],
  naturezaActive: null,
  isLoading: false,
  error: null,
  openModal: false,
});

/* Reducers */

const getNaturezasRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const getNaturezasSuccess = (state, { naturezas }) => {
  console.log('📥 [naturezasReducer] Recebendo naturezas:', {
    count: naturezas?.length || 0,
    isArray: Array.isArray(naturezas),
    naturezas: naturezas,
  });
  
  return state.merge({
    naturezas,
    isLoading: false,
    error: null,
  });
};

const getNaturezasFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

const addNaturezaRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const addNaturezaSuccess = (state, { natureza }) =>
  state.merge({
    naturezas: [...state.naturezas, natureza],
    isLoading: false,
    error: null,
  });

const addNaturezaFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

const updateNaturezaRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const updateNaturezaSuccess = (state, { natureza }) =>
  state.merge({
    naturezas: state.naturezas.map((item) =>
      item.id === natureza.id ? natureza : item
    ),
    isLoading: false,
    error: null,
  });

const updateNaturezaFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

const removeNaturezaRequest = (state) =>
  state.merge({
    isLoading: true,
  });

const removeNaturezaSuccess = (state, { id }) =>
  state.merge({
    naturezas: state.naturezas.filter((item) => item.id !== id),
    isLoading: false,
    error: null,
  });

const removeNaturezaFailure = (state, { error }) =>
  state.merge({
    error,
    isLoading: false,
  });

const openModal = (state) =>
  state.merge({
    openModal: true,
  });

const closeModal = (state) =>
  state.merge({
    openModal: false,
    naturezaActive: null,
  });

const setNaturezaActive = (state, { natureza }) =>
  state.merge({
    naturezaActive: natureza,
  });

/* Reducers to types */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_NATUREZAS_REQUEST]: getNaturezasRequest,
  [Types.GET_NATUREZAS_SUCCESS]: getNaturezasSuccess,
  [Types.GET_NATUREZAS_FAILURE]: getNaturezasFailure,
  [Types.ADD_NATUREZA_REQUEST]: addNaturezaRequest,
  [Types.ADD_NATUREZA_SUCCESS]: addNaturezaSuccess,
  [Types.ADD_NATUREZA_FAILURE]: addNaturezaFailure,
  [Types.UPDATE_NATUREZA_REQUEST]: updateNaturezaRequest,
  [Types.UPDATE_NATUREZA_SUCCESS]: updateNaturezaSuccess,
  [Types.UPDATE_NATUREZA_FAILURE]: updateNaturezaFailure,
  [Types.REMOVE_NATUREZA_REQUEST]: removeNaturezaRequest,
  [Types.REMOVE_NATUREZA_SUCCESS]: removeNaturezaSuccess,
  [Types.REMOVE_NATUREZA_FAILURE]: removeNaturezaFailure,
  [Types.OPEN_MODAL]: openModal,
  [Types.CLOSE_MODAL]: closeModal,
  [Types.SET_NATUREZA_ACTIVE]: setNaturezaActive,
});

